// :cow: Cosmose CONFIDENTIAL :iso:
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State, STATE_NAME_SELECT_CATEGORY } from './select-category.reducer';

const currentState = createFeatureSelector<State>(STATE_NAME_SELECT_CATEGORY);

export const selectCategoryListResponse = createSelector(
  currentState,
  (state: State) => state.response,
);

export const selectCategoryListError = createSelector(
  currentState,
  (state: State) => state.responseError,
);

export const selectCategoryListShowSkeleton = createSelector(
  currentState,
  (state: State) => state.responseLoading,
);


